import { useQuery } from '@tanstack/react-query';
import { getPatientServiceItems } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const usePatientServiceItemsQuery = (patientId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'patient', patientId, 'serviceItems' ],
    queryFn: async () => {
      const response = await getPatientServiceItems(patientId);

      return response.data;
    },
    ...opts,
  });
};
